import {useParams} from 'react-router-dom'

export const useParamsInteger = (params: string[]): {[key: string]: number} => {
  const urlParams = useParams<{[key: string]: string}>()
  return params.reduce(
    (prev, curr) => ({
      ...prev,
      [curr]: parseInt(urlParams[curr], 10),
    }),
    {},
  )
}
